/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_ReportInputs */

const en_profile_report = /** @type {(inputs: Profile_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report User`)
};

const es_profile_report = /** @type {(inputs: Profile_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reportar Usuario`)
};

const fr_profile_report = /** @type {(inputs: Profile_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signaler l'utilisateur`)
};

const de_profile_report = /** @type {(inputs: Profile_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzer melden`)
};

const id_profile_report = /** @type {(inputs: Profile_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laporkan Pengguna`)
};

/** @type {(inputs: Profile_ReportInputs) => LocalizedString} */
const ja_profile_report = en_profile_report;

/** @type {(inputs: Profile_ReportInputs) => LocalizedString} */
const zh_profile_report = en_profile_report;

/** @type {(inputs: Profile_ReportInputs) => LocalizedString} */
const ar_profile_report = en_profile_report;

/** @type {(inputs: Profile_ReportInputs) => LocalizedString} */
const it_profile_report = en_profile_report;

/** @type {(inputs: Profile_ReportInputs) => LocalizedString} */
const ru_profile_report = en_profile_report;

/** @type {(inputs: Profile_ReportInputs) => LocalizedString} */
const pt_profile_report = en_profile_report;

/** @type {(inputs: Profile_ReportInputs) => LocalizedString} */
const ko_profile_report = en_profile_report;

/**
* | output |
* | --- |
* | "Report User" |
*
* @param {Profile_ReportInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const profile_report = /** @type {((inputs?: Profile_ReportInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_ReportInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_report(inputs)
	if (locale === "es") return es_profile_report(inputs)
	if (locale === "fr") return fr_profile_report(inputs)
	if (locale === "de") return de_profile_report(inputs)
	if (locale === "ja") return ja_profile_report(inputs)
	if (locale === "zh") return zh_profile_report(inputs)
	if (locale === "ar") return ar_profile_report(inputs)
	if (locale === "id") return id_profile_report(inputs)
	if (locale === "it") return it_profile_report(inputs)
	if (locale === "ru") return ru_profile_report(inputs)
	if (locale === "pt") return pt_profile_report(inputs)
	return ko_profile_report(inputs)
});